import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js'
import 'react-tooltip/dist/react-tooltip.css';
import './App.css';
import Home from './pages/Home';
import ProjectsList from './pages/ProjectsList';
import ProjectsDetail from './pages/ProjectsDetail';
import Login from './pages/Login';
import Logout from './pages/Logout';
import ProjectsForm from './pages/ProjectsForm';
import { ToastContainer } from 'react-toastify';
import CustomersList from './pages/CustomersList';
import CustomersDetail from './pages/CustomersDetail';
import CustomersForm from './pages/CustomersForm';
import { fetchWithAuth } from './services/Fetch';
import logo from "./assets/images/logo.png"

function App() {
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (window.location.pathname === '/login') {
            setLoading(false);
            return;
        }

        fetchWithAuth('/me')
            .then(() => setLoading(false))
            .catch(() => window.location.href = '/login');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return <>
            <header>
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                    <div className="container-fluid">                        
                        <a className="navbar-brand" href="/">
                            <img src={logo} alt="Logo" width="50" />&nbsp;AMEOS Security Console
                        </a>
                    </div>
                </nav>
            </header>            
            <main className="mt-4 mb-4">
                <div className="container">
                    <p>Chargement...</p>
                </div>
            </main>
            
            <footer className="container-fluid mt-5 bg-light">
                <div className="col-12 p-4">
                <p className="text-dark m-0">&copy; 2025 AMEOS</p>
                </div>
            </footer>
        </>;
    }

    return <>
        <ToastContainer />
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/projects" element={<ProjectsList />} />
                <Route path="/projects/:id" element={<ProjectsDetail />} />
                <Route path="/projects/:id/edit" element={<ProjectsForm />} />
                <Route path="/projects/new" element={<ProjectsForm />} />
                <Route path="/customers" element={<CustomersList />} />
                <Route path="/customers/:id" element={<CustomersDetail />} />
                <Route path="/customers/new" element={<CustomersForm />} />
                <Route path="/customers/:id/edit" element={<CustomersForm />} />
            </Routes>
        </BrowserRouter>
    </>;
}

export default App;
